import { render } from "./SingleFileUpload.vue?vue&type=template&id=546afec2&ts=true"
import script from "./SingleFileUpload.vue?vue&type=script&lang=ts"
export * from "./SingleFileUpload.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__